"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const PrismicError = require("../errors/PrismicError.cjs");
const findRef = (refs, filter) => {
  const ref = refs.find((ref2) => filter(ref2));
  if (!ref) {
    throw new PrismicError.PrismicError("Ref could not be found.", void 0, void 0);
  }
  return ref;
};
exports.findRef = findRef;
//# sourceMappingURL=findRef.cjs.map
